/* Cart lines (drawer + page): quantity, remove, note, share link. */
(() => {
  if (window.__nsCartLines) return;
  window.__nsCartLines = true;
  let noteTimer;
  const busy = (el, on) => el?.closest('.cart-line')?.classList.toggle('is-busy', on);

  document.addEventListener('change', (e) => {
    const qty = e.target.closest('[data-line-qty]');
    if (qty) {
      busy(qty, true);
      NS.cart.change(Number(qty.dataset.lineQty), Math.max(0, Number(qty.value))).catch((err) => NS.announce(err.description || err.message)).finally(() => busy(qty, false));
    }
  });
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-line-remove]');
    if (rm) { busy(rm, true); NS.cart.change(Number(rm.dataset.lineRemove), 0); }
    const share = e.target.closest('[data-share-cart]');
    if (share) {
      fetch('/cart.js').then((r) => r.json()).then((cart) => {
        const url = `${location.origin}/cart/${cart.items.map((i) => `${i.variant_id}:${i.quantity}`).join(',')}`;
        (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(() => NS.toast(window.NSStrings?.shareCopied || 'Copied'), () => prompt('', url));
      });
    }
  });
  document.addEventListener('input', (e) => {
    const note = e.target.closest('[data-cart-note]'); if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(() => NS.cart.update({ note: note.value }), 500);
  });
})();
